import type { TourismItem } from "@/types/tourism";

export type ClassificationCategoryCode =
  | "AC"
  | "EV"
  | "EX"
  | "FD"
  | "HS"
  | "LS"
  | "NA"
  | "SH"
  | "VE"
  | "C01";

export type LocalizedCategoryLabel = {
  value: ClassificationCategoryCode;
  label: string;
  en: string;
  ja: string;
  zh: string;
  de: string;
  fr: string;
  contentTypeId?: string;
};

export const CLASSIFICATION_CATEGORIES: LocalizedCategoryLabel[] = [
  {
    value: "NA",
    label: "자연관광",
    en: "Nature Tourism",
    ja: "自然観光",
    zh: "自然旅游",
    de: "Naturtourismus",
    fr: "Tourisme naturel",
    contentTypeId: "12",
  },
  {
    value: "HS",
    label: "역사관광",
    en: "Historical Tourism",
    ja: "歴史観光",
    zh: "历史旅游",
    de: "Historischer Tourismus",
    fr: "Tourisme historique",
    contentTypeId: "12",
  },
  {
    value: "VE",
    label: "문화관광",
    en: "Cultural Tourism",
    ja: "文化観光",
    zh: "文化旅游",
    de: "Kulturtourismus",
    fr: "Tourisme culturel",
    contentTypeId: "12",
  },
  {
    value: "EX",
    label: "체험관광",
    en: "Experience Tourism",
    ja: "体験観光",
    zh: "体验旅游",
    de: "Erlebnistourismus",
    fr: "Tourisme d'experience",
    contentTypeId: "12",
  },
  {
    value: "LS",
    label: "레저스포츠",
    en: "Leisure & Sports",
    ja: "レジャースポーツ",
    zh: "休闲体育",
    de: "Freizeit & Sport",
    fr: "Loisirs et sports",
    contentTypeId: "28",
  },
  {
    value: "FD",
    label: "음식",
    en: "Food",
    ja: "グルメ",
    zh: "美食",
    de: "Essen",
    fr: "Gastronomie",
    contentTypeId: "39",
  },
  {
    value: "SH",
    label: "쇼핑",
    en: "Shopping",
    ja: "ショッピング",
    zh: "购物",
    de: "Einkaufen",
    fr: "Shopping",
    contentTypeId: "38",
  },
  {
    value: "AC",
    label: "숙박",
    en: "Accommodation",
    ja: "宿泊",
    zh: "住宿",
    de: "Unterkunft",
    fr: "Hebergement",
    contentTypeId: "32",
  },
  {
    value: "EV",
    label: "축제/공연/행사",
    en: "Festival/Performance/Event",
    ja: "祭り/公演/イベント",
    zh: "节庆/演出/活动",
    de: "Festival/Auffuehrung/Veranstaltung",
    fr: "Festival/spectacle/evenement",
    contentTypeId: "15",
  },
  {
    value: "C01",
    label: "추천코스",
    en: "Recommended Course",
    ja: "おすすめコース",
    zh: "推荐路线",
    de: "Empfohlene Route",
    fr: "Circuit recommande",
    contentTypeId: "25",
  },
];

export const CLASSIFICATION_CATEGORY_MAP = CLASSIFICATION_CATEGORIES.reduce(
  (acc, category) => {
    acc[category.value] = category;
    return acc;
  },
  {} as Record<ClassificationCategoryCode, LocalizedCategoryLabel>
);

export const getClassificationCategoryName = (code?: string): string => {
  if (!code) return "기타";
  return CLASSIFICATION_CATEGORY_MAP[code as ClassificationCategoryCode]?.label || code;
};

export const getTourismItemCategoryName = (item: TourismItem): string => {
  const nameFromApi =
    item.lclsSystm1Nm ||
    item.lclsSystm2Nm ||
    item.lclsSystm3Nm;

  if (nameFromApi) return nameFromApi;

  return getClassificationCategoryName(
    item.lclsSystm1 ||
      item.lclsSystm1Cd ||
      item.category ||
      item.cat1
  );
};
